document.addEventListener('DOMContentLoaded', function () {
    // the detail page shows the error in the page itself, and wants the same last line
    document.querySelectorAll('pre.contract-batch-error-text').forEach(function (block) {
        block.scrollTop = block.scrollHeight;
    });

    const modal = document.querySelector('#contract-batch-errors-modal');
    const buttons = document.querySelectorAll('.contract-batch-error-button');
    if (!modal || !buttons.length) {
        return;
    }

    const text = modal.querySelector('.contract-batch-error-text');
    const record = modal.querySelector('.modal-title .record');

    /**
     * @returns {string} the CSRF token, or empty when the meta tag is gone
     */
    function csrfToken() {
        const meta = document.querySelector('meta[name="csrf-token"]');
        return meta ? meta.content : '';
    }

    /**
      * Scroll to the end: a python traceback puts the cause on its last line.
      */
    function toBottom() {
        text.scrollTop = text.scrollHeight;
    }

    /**
     * Show the stored import error in the modal.
     *
     * @param {string} message - the error text as it came from the server
     */
    function show(message) {
        text.textContent = message;
        // scrollHeight is nothing while the modal is still hidden, so wait for it to be up
        $(modal).one('shown.bs.modal', toBottom);
        $(modal).modal('show');
        toBottom();
    }

    buttons.forEach(function (button) {
        button.addEventListener('click', function () {
            record.textContent = button.dataset.record || '';
            show(text.dataset.loading || '...');

            fetch(button.dataset.errorsUrl, {
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': csrfToken(),
                },
            }).then(function (response) {
                return response.json().catch(function () {
                    return null;
                });
            }).then(function (data) {
                if (!data) {
                    show(text.dataset.failed || '');
                    return;
                }
                // an error status without a stored trace is still worth saying out loud
                show(data.errors || text.dataset.empty || '');
            }).catch(function () {
                show(text.dataset.failed || '');
            });
        });
    });
});
